import script from "./ConfirmInterestPayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmInterestPayments.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmInterestPayments.vue?vue&type=style&index=0&id=31213cd2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31213cd2"]])

export default __exports__